import { render, staticRenderFns } from "./tiscFieldset.vue?vue&type=template&id=34f9a62f&"
import script from "./tiscFieldset.vue?vue&type=script&lang=js&"
export * from "./tiscFieldset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports